import { Home, Notifications } from '@mui/icons-material';
import { Container, Box, Paper, Typography, Breadcrumbs, Stack } from '@mui/material';
type Props = {
  header?: React.ReactNode;
  children?: React.ReactNode;
};

export const PageContainer = (props: Props) => {
  const { header, children } = props;

  return (
    <Container maxWidth="xl" sx={{ py: 4 }}>
      <Box sx={{ mb: 3 }}>
        <Breadcrumbs aria-label="breadcrumb" sx={{ mb: 1.5 }}>
          <Typography color="inherit" sx={{ display: 'flex', alignItems: 'center' }}>
            <Home sx={{ mr: 0.5 }} fontSize="inherit" />
            Início
          </Typography>
          <Typography color="text.primary" sx={{ display: 'flex', alignItems: 'center' }}>
            <Notifications sx={{ mr: 0.5 }} fontSize="inherit" />
            List of Failed Events
          </Typography>
        </Breadcrumbs>

        <Typography variant="h4" component="h1" gutterBottom fontWeight={600}>
          Eventos com erro
        </Typography>

        <Typography variant="body1" color="text.secondary" sx={{ mb: 2 }}>
          Gerencie os eventos falhos da organizacao
        </Typography>
      </Box>

      <Paper elevation={1} sx={{ borderRadius: 2, overflow: 'hidden' }}>
        <Stack
          direction="row"
          alignItems="flex-start"
          justifyContent="space-between"
          sx={{
            p: 3,
            borderBottom: 1,
            borderColor: 'divider',
            bgcolor: 'grey.50',
            gap: 2
          }}>
          {header}
        </Stack>

        <Box sx={{ px: 2, py: 2 }}>{children}</Box>
      </Paper>
    </Container>
  );
};
